import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { encryptData } from "../../EncryptDecrypt";
import {
  splitContactNumber,
  createContactNumber,
  splitHomeContactNumber,
} from "../../../utils/phoneNumberSupport";
import {
  createAccountOptions,
  FormikObjEdit,
  editBasicFields,
  editBasicFieldsPractionerRowOne,
  genderOptions,
  editBasicFieldsPractionerRowThree,
  editBasicFieldsPractionerRowEight,
} from "./Constants";
import { countryList, caregions, usregions } from "../../../utils/constants";
import { useCustomRolesQuery } from "../../../hooks/ReactQueryHooks/useCustomRolesQuery";
import MultiSelect from "../../common/textfield/MultiSelect";
import {
  editUser,
  getAgentId,
  getCustomRoles,
  getRelatedPerson,
  getSingleUser,
  updateAgentId,
} from "../../api/Individual";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import Fields from "./Fields";
import { useSelector } from "react-redux";
import Switch from "@mui/material/Switch";
import ReactDatePicker from "../../common/textfield/ReactDatePicker";
import UpdateDetailsIcon from "../../../assets/images/update.svg";
import { ViewDate } from "../../../utils/DateSupport";
import { getOrganization, getOrganizationSettings } from "../../api/Organization";
import { validation, conditionalValidation } from "../../../utils/constants";

export function EditIndividual({
  modalShow,
  handleShow,
  refreshTable,
  isReadOnly,
  typeOfUser,
  organizations,
  organizationsData,
  handleDelete,
  handleEnableClick,
}) {
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [loadingUserData, setLoadingUserData] = useState(false);
  const [rolesOptions, setRolesOptions] = useState([{ name: "-----" }]);

  const [regionOptions, setRegionOptions] = useState([]);
  const [roleSelected, setRoleSelected] = useState(false);
  const [createdAt, setCreatedAt] = useState("");
  const [defaultValue, setDefaultValue] = useState([]);
  const [typeRelatedPerson, setTypeRelatedPerson] = useState(false);
  const [typePractitioner, setTypePractitioner] = useState(false);
  const [createAccount, setCreateAccount] = useState(false);
  const [createAcctFlag, setCreateAcctFlag] = useState(false);
  const [createAccountValue, setCreateAccountValue] = useState(false);
  const [childrenOrgs, setChildrenOrgs] = useState([]);
  const [defaultValuechildOrgs, setDefaultValuechildOrgs] = useState([]);
  const [defaultCountryList, setDefaultCountryList] = useState([]);

  const [enforcePractitionerDOB, setEnforcePractitionerDOB] = useState(false);
  const [enforcePractitionerGender, setEnforcePractitionerGender] = useState(false);
  const [enforcePractitionerAddress, setEnforcePractitionerAddress] = useState(false);
  const [enforcePractitionerCountry, setEnforcePractitionerCountry] = useState(false);
  const [enforcePractitionerProvince, setEnforcePractitionerProvince] = useState(false);
  const [enforcePractitionerCity, setEnforcePractitionerCity] = useState(false);
  const [enforcePractitionerPostal, setEnforcePractitionerPostal] = useState(false);

  const permissions = useSelector((state) => state?.auth?.user?.permissions);
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const practitioner = userRoles?.includes("Practitioner");
  const hasAccess =
    ((permissions?.includes("practitioner-create") && practitioner) ||
      userRoles?.includes("Super-Admin"));
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const isCTIEnabledRef = useRef(false);

  if (!hasAccess) {
    isReadOnly = true;
    typeOfUser = "";
  }

  const onSuccessCustomRoles = (data) => {
    setRolesOptions(
      data?.map((role) => (role = { ...role, name: role?.display, value: role?.id }))
    );
  };


  const { refetch: cutomRolesRefetch } = useCustomRolesQuery({
    orgIds: [modalShow?.managingOrganization?.[0]?.reference?.split("/")?.[1]],
    onSuccess: onSuccessCustomRoles,
  });

  const setCTIstatus = async (orgId) => {
    const response = await getOrganization(orgId);
    isCTIEnabledRef.current = response?.data?.ctiSettings?.enabled;
  };

  const loadOrgEnforcements = async (orgId) => {
    if (!orgId) return;
    try {
      const res = await getOrganizationSettings(orgId);
      if (res?.status) {
        const p = res.data?.practitioner || {};
        setEnforcePractitionerDOB(!!p.dob);
        setEnforcePractitionerGender(!!p.gender);
        setEnforcePractitionerAddress(!!p.address);
        setEnforcePractitionerCountry(!!p.country);
        setEnforcePractitionerProvince(!!p.province);
        setEnforcePractitionerCity(!!p.city);
        setEnforcePractitionerPostal(!!p.postalCode);
      }
    } catch (err) {
      failed(
        err?.response?.data?.message || err?.response?.data?.error || err.message
      );
    }
  };

  const handleOrgChange = async (event) => {
    const value = event?.target?.value;
    const _childrenOrgs = organizations
      ?.filter((org) => org.value.startsWith(value) && org.value !== value)
      .map((org) => ({ ...org, id: org.value }));

    setChildrenOrgs(_childrenOrgs);
    formik.setFieldValue("organization", value);

    try {
      const res = await getCustomRoles([value]);
      setRolesOptions(
        res?.data?.map((role) => ({
          ...role,
          name: role?.display,
          value: role?.id,
        }))
      );
    } catch (err) {
      failed(
        err?.response?.data?.message || err?.response?.data?.error || err.message
      );
    }

    await setCTIstatus(value);
    await loadOrgEnforcements(value);
  };

  const handleRoleChange = (event) => {
    const value = event?.target?.value;
    formik.setFieldValue("role", value);
    const roleType = rolesOptions?.filter((role) => role?.id === value);
    setRoleSelected(
      ["clinician", "organizationadministrator"].includes(roleType?.[0]?.code)
    );
  };

  const handleCountryChange = (selectedCountries = []) => {
    let mergedRegions = [];
    if (selectedCountries.includes("CA")) mergedRegions = mergedRegions.concat(caregions);
    if (selectedCountries.includes("US")) mergedRegions = mergedRegions.concat(usregions);
    const deduped = Array.from(new Map(mergedRegions.map((r) => [r.value, r])).values());
    setRegionOptions(deduped);
    formik.setFieldValue("scopeOfPractice", []);
  };

  const formik = useFormik({
    ...FormikObjEdit,
    validationSchema: 
        Yup.object({
          
          first_name: conditionalValidation(
            Yup.string()
              .max(50, "Must be 50 characters or less")
              .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
            {
              mandatory: true,
              label: "First name",
              validation
            }),

      last_name: conditionalValidation(
          Yup.string()
          .max(50, "Must be 50 characters or less")
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            mandatory: true,
            label: "Last name",
            validation
          }),

      date_of_birth: conditionalValidation(
        Yup.string()
          .nullable()
          .test(
            "valid-format",
            "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
            function (value) {
              if (value) { 
                const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
                const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
                if (!isValid1 && !isValid2) return false; 
                const dob = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY"); 
                
                if (dob.isAfter(moment())) {
                  return this.createError({
                    message: "Date of birth cannot be in the future.",
                  });
                }
                let minDate = moment().subtract(125, "years");
                if (dob.isBefore(minDate)) {
                  return this.createError({
                    message: "Date of Birth cannot be more than 125 years ago.",
                  });
                } 
              }
              return true;
            }
          ),
          {
            validation,
            mandatory: enforcePractitionerDOB,
            label: "Date of Birth"
          }),

      phone_number: conditionalValidation(
          Yup.string().matches(
          /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
          "Enter Valid Phone Number."),
          {
            validation,
            label: "Phone Number"
          }
      ),

      home_phone_number: conditionalValidation(
          Yup.string().matches(
          /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
          "Enter Valid Home Phone Number."),
          {
            validation,
            label: "Home Phone Number"
          }
      ),

      ext: conditionalValidation(
        Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
        { validation }
      ),
      address: conditionalValidation(
        Yup.string().when(["userType"], (userType, schema) => {
        const isPract = userType?.[0] === "Practitioner" || userType === "Practitioner";
        return isPract && enforcePractitionerAddress
          ? schema.required("Required address field").matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
          : schema.matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.");
        }),
        {
          validation,
          label: "Address"
        }
      ),

      city: conditionalValidation(
          Yup.string().when(["userType"], (userType, schema) => {
          const isPract = userType?.[0] === "Practitioner" || userType === "Practitioner";
          return isPract && enforcePractitionerCity
            ? schema.required("Required city field").matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
            : schema.matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.");
          }),
          {
            validation,
            label: "City"
          }),

      email: conditionalValidation(
        createAccountValue
        ? Yup.string()
            .email("Invalid email address")
            .required("Required email field")
            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
        : Yup.string().email("Invalid email address"), 
        {
          validation,
          label: "Email",
          mandatory: createAccountValue
        }),

      country: conditionalValidation(
          Yup.string().when(["userType"], (userType, schema) => {
          const isPract = userType?.[0] === "Practitioner" || userType === "Practitioner";
          return isPract && enforcePractitionerCountry
            ? schema.required("Required country field").matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
            : schema.matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.");
          }),
          {
            validation,
            label: "Country"
          }),

      region: conditionalValidation(
          Yup.string().when(["userType"], (userType, schema) => {
          const isPract = userType?.[0] === "Practitioner" || userType === "Practitioner";
          return isPract && enforcePractitionerProvince
            ? schema.required("Required region field").matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
            : schema.matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.");
          }),
          {
            validation,
            label: "Province/State"
          }),

      gender: conditionalValidation(
          Yup.string().when(["userType"], (userType, schema) => {
            const isPract = userType?.[0] === "Practitioner" || userType === "Practitioner";
            return isPract && enforcePractitionerGender
              ? schema.required("Required gender field").matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
              : schema.matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.");
          }),
          {
            validation,
            label: "Gender"
          }),

      postalCode: Yup.string().when(["userType", "country"], (userType, country, schema) => {
        const isPract = userType?.[0] === "Practitioner" || userType === "Practitioner";
        conditionalValidation(
            country === "US"
              ? Yup.number()
                .typeError("Zip code must be a number")
              : Yup.string()
                .matches(
                  /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                  "Postal code must be in A1A 1A1 format."
                ),
              {
                validation,
                mandatory: isPract,
                label: (country === "US")? "Zip code":"Postal code"})
      }),

      isPatient: Yup.boolean(),
      related_to: conditionalValidation(
        Yup.string(),
        {
          validation
        }),

      role: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: typeOfUser === "Practitioner" && typePractitioner,
          label: "Role"
        }),

      scopeOfPractice: Yup.array().when("role", (role, schema) => {
        if (role && roleSelected && defaultValue?.length) {
          return schema
            .min(1, "Required scope Of Practice field")
            .required("Required scope Of Practice field");
        }
        return schema;
      }),

      create_account: createAccount
        ? Yup.string().required("Required Create Account field")
        : Yup.string(),

      relationship: conditionalValidation(
        typeOfUser === "RelatedPerson" && typeRelatedPerson
          ? Yup.string().required("Required Relationship field")
          : Yup.string(),
        {
          validation,
          label: "Relationship"
        }),

      hcn: conditionalValidation(
        modalShow?.type?.[0] === "Patient"
          ? Yup.string().when("type", (type, schema) => schema.required("Patient Identifier is required"))
          : Yup.string(),
          {
            validation,
            label: "Patient Identifier"
          }),
      agentId: conditionalValidation(
        Yup.string().matches(/^\S+$/,"Agent Id cannot contain any whitespace"),
          {
            validation,
            label: "Agent Id"
          }),
      license: conditionalValidation(
        Yup.string(),
          {
            validation,
            label: "License"
          }),
      qualification: conditionalValidation(
        Yup.string(),
          {
            validation,
            label: "College"
          }),
      excludedOrgIds: Yup.array().of(Yup.string()).required(),
    }),
    onSubmit: (values) => {
      values.first_name = values.first_name.trim();
      values.last_name = values.last_name.trim();
      values.email = values.email.trim();
      values.gender = values.gender.trim();
      values.address = values.address.trim();
      values.city = values.city.trim();
      values.country = values.country.trim();
      values.region = values.region.trim();
      values.postalCode = values.postalCode.trim();
      values.relationship = values.relationship.trim();
      values.hcn = values.hcn.trim();
      values.excludedOrgIds = values.excludedOrgIds;
      console.log(values?.date_of_birth);
      const type = rolesOptions?.filter((role) => role?.id === values?.role);
      const state = values?.region;
      
      // Normalize invalid dates to empty string
      if (values?.date_of_birth && moment(values.date_of_birth).isValid()) {
        values.date_of_birth = moment(values.date_of_birth).format("MM-DD-YYYY");
      } else {
        values.date_of_birth = "";
      }
      
      const phoneNumber = createContactNumber(values);

      const encryptedData = {
        first_name: encryptData(values?.first_name?.toLowerCase()),
        last_name: encryptData(values?.last_name?.toLowerCase()),
        full_name: encryptData(
          [values?.first_name?.toLowerCase(), values?.last_name?.toLowerCase()].join(" ")
        ),
        address: encryptData(values?.address),
        date_of_birth: encryptData(values?.date_of_birth || ""),
        phone_number: encryptData(phoneNumber),
        postalCode: encryptData(values?.postalCode?.toUpperCase()),
        city: encryptData(values?.city),
        gender: encryptData(values?.gender),
        email: encryptData(values?.email?.toLowerCase()),
        relationship: encryptData(values?.relationship),
        healthCardNumber: encryptData(values?.hcn),
        excludedOrgIds: encryptData(values?.excludedOrgIds),
      };

      setBtnLoading(true);

      editUser(
        values,
        encryptedData,
        organizationsData,
        state,
        type,
        [],
        null,
        modalShow?.type,
        createAcctFlag,
        adminOrgs?.[0]?.id
      )
        .then((res) => {
          if (res?.status === true) {
            navigate("/app/manage-individuals");
            success(res?.message);
            handleShow();
            refreshTable();
          } else {
            failed(res?.error);
          }
        })
        .catch((res) => {
          failed(res?.response?.data?.message || res?.response?.data?.error || res?.message);
        })
        .finally(() => setBtnLoading(false));
    },
  });

  const flattenedArray = editBasicFields.flatMap((section) => section);
  const emailField = flattenedArray.find((field) => field.keyField === "email");
  if (emailField) {
    emailField.hideRequired = !createAccountValue;
    emailField.isReadOnly = !createAcctFlag;
  }

  const handleCreateAccountChange = (e) => {
    const value = e?.target?.value;
    setCreateAccountValue(value == "true");
    formik?.setFieldValue("create_account", value);
  };

  const handleFormChange = (e) => {
    if (e?.target?.id === "country") {
      formik.setFieldValue("region", "");
      formik.setFieldValue("postalCode", "");
      formik.setFieldValue("city", "");
      formik.setFieldValue("address", "");
    }
  };

  const handlePostalCodeChange = (e) => {
    const { value } = e?.target;
    let spacedValue = value;
    if (formik?.values?.country !== "US") {
      const formattedValue = value.replace(/[^A-Za-z0-9]/g, "");
      spacedValue = formattedValue.replace(/^([A-Za-z0-9]{3})([A-Za-z0-9]+)/, "$1 $2");
    }
    formik?.setFieldValue("postalCode", spacedValue);
  };

  useEffect(() => {
    if (!modalShow?.id) return;
    (async () => {
      setLoadingUserData(true);
      try {
        if (modalShow?.type?.[0] == "Practitioner") {
          typeOfUser = "Practitioner";
        }
        const apiBody = {
          id: modalShow?.id,
          type: typeOfUser,
          userOrgId: adminOrgs?.[0]?.id,
        };
        const res = await getSingleUser(apiBody);

        const typeObj = {};
        res?.data?.type?.forEach((t) => (typeObj[t] = t));
        setCreatedAt(res?.data?.createdAt);
        
        const organization = res?.data?.managingOrganization?.[0]?.reference?.split("/");

        cutomRolesRefetch({
          orgIds: organization?.[1],
          onSuccessCustomRoles,
        });

        formik.setFieldValue("first_name", res?.data?.name?.[0]?.given?.[0] || "");
        formik.setFieldValue("last_name", res?.data?.name?.[0]?.family || "");
        if (res?.data?.birthDate && moment(res?.data?.birthDate).isValid()) {
          formik.setFieldValue(
            "date_of_birth",
            moment(res?.data?.birthDate).format("MM-DD-YYYY")
          );
        }

        formik.setFieldValue(
          "phone_number",
          splitContactNumber(res?.data?.telecom?.find((ele) => ele?.system === "phone")?.value || "")
            .phone_number.replace(/^\+1/, "")
        );
        formik.setFieldValue(
          "ext",
          splitContactNumber(res?.data?.telecom?.find((ele) => ele?.system === "phone")?.value || "")
            .ext
        );
        formik.setFieldValue(
          "email",
          res?.data?.telecom?.find((ele) => ele?.system === "email")?.value || ""
        );

        formik.setFieldValue("id", res?.data?.id || "");
        formik.setFieldValue("address", res?.data?.address?.[0]?.line?.[0] || "");
        formik.setFieldValue("postalCode", res?.data?.address?.[0]?.postalCode || "");
        formik.setFieldValue("city", res?.data?.address?.[0]?.city || "");
        formik.setFieldValue("gender", res?.data?.gender || "");
        formik.setFieldValue("country", res?.data?.address?.[0]?.country || "");
        formik.setFieldValue("region", res?.data?.address?.[0]?.state || "");
        formik.setFieldValue("organization", organization?.[1] || "");
        formik.setFieldValue( "license", res?.data?.qualification?.[0]?.identifier?.[0]?.value || "" );
        formik.setFieldValue( "qualification", res?.data?.qualification?.[0]?.code?.coding?.[0]?.text || "");
        formik.setFieldValue( "designation", res?.data?.designation || "");

        await setCTIstatus(res?.data?.orgId);
        await loadOrgEnforcements(organization?.[1]);

        // Automatically fetch agent ID if CTI is enabled
        if (isCTIEnabledRef.current) {
          const practitionerLink = modalShow?.link?.[0]?.target?.reference || res?.data?.link?.[0]?.target?.reference;
          const [, practitionerId] = (practitionerLink || "").split("/");
          if (practitionerId) {
            getAgentId(practitionerId).then((agentRes) => {
              if (agentRes?.data) {
                formik.setFieldValue("agentId", agentRes?.data);
              } else {
                formik.setFieldValue("agentId", "");
              }
            }).catch(() => {
              formik.setFieldValue("agentId", "");
            });
          }
        }

        const _childrenOrgs = organizations
          ?.filter((org) => org.value.startsWith(organization?.[1]) && org.value !== organization?.[1])
          .map((org) => ({ ...org, id: org.value }));
        setChildrenOrgs(_childrenOrgs);
        setDefaultValuechildOrgs(res?.data?.excludedOrgIds);
        formik.setFieldValue("excludedOrgIds", res?.data?.excludedOrgIds || []);

        if (res?.data?.type == "Super-Admin" || modalShow?.type?.[0] == "Super-Admin") {
          formik.setFieldValue(
            "home_phone_number",
            splitHomeContactNumber(
              res?.data?.telecom?.find((ele) => ele?.use === "home")?.value || ""
            ).home_phone_number.replace(/^\+1/, "")
          );
          formik.setFieldValue("userType", "Super-Admin");
          setTypePractitioner(false);
          setRoleSelected(false);
        } else if (typeObj.Practitioner || res?.data?.type == "Practitioner" || modalShow?.type?.[0] == "Practitioner") {
          formik.setFieldValue(
            "home_phone_number",
            splitHomeContactNumber(
              res?.data?.telecom?.find((ele) => ele?.use === "home")?.value || ""
            ).home_phone_number.replace(/^\+1/, "")
          );

          formik.setFieldValue("userType", "Practitioner");
          setTypePractitioner(true);
          setRoleSelected(
            ["clinician", "organizationadministrator"].includes(
              res?.data?.role?.coding?.[0]?.code
            )
          );

          const scopes = res?.data?.scopeOfPractice || [];
          const mergedRegions = [
            ...(scopes.some((s) => s.startsWith("CA-")) ? caregions : []),
            ...(scopes.some((s) => s.startsWith("US-")) ? usregions : []),
          ];
          setRegionOptions(mergedRegions);
          setDefaultValue(res?.data?.scopeOfPractice);

          const _defaultCountryList = countryList
            .map((c) => c.value)
            .filter((code) => scopes.some((s) => s.startsWith(code + "-")));
          setDefaultCountryList(_defaultCountryList);

          formik.setFieldValue("role", res?.data?.role?.coding?.[0]?.id);
          formik.setFieldValue("scopeOfPractice", res?.data?.scopeOfPractice);

          if ((typeObj.Practitioner || res?.data?.type === "Practitioner") && typeObj.Patient) {
            formik.setFieldValue("isPatient", true);
          } else {
            formik.setFieldValue("isPatient", false);
          }
        } else {
          setTypePractitioner(false);
          setRoleSelected(false);
        }

        if (
          typeOfUser === "Patient" ||
          (typeObj.Patient && !((typeObj.Practitioner || res?.data?.type === "Practitioner") || typeObj.RelatedPerson))
        ) {
          formik.setFieldValue("userType", "Patient");
          setCreateAccount(true);
          if (res?.data?.accountCreated === false) setCreateAcctFlag(true);
          if (res?.data?.accountCreated === true) setCreateAccountValue(true);
          formik.setFieldValue("create_account", res?.data?.accountCreated === true ? "true" : "false");
          formik.setFieldValue(
            "hcn",
            res?.data?.patient_identifier?.find((ele) => ele?.type === "HCN")?.value || ""
          );
        } else {
          setCreateAccount(false);
        }

        if (typeObj.RelatedPerson) {
          formik.setFieldValue("userType", "RelatedPerson");
          setTypeRelatedPerson(true);
          const rp = await getRelatedPerson(res?.data?.patientRefId);
          formik.setFieldValue("relationship", rp?.data?.[0]?.relationship || "");
          formik.setFieldValue("related_to", rp?.data?.[0]?.patientName?.[0]?.text || "");
          formik.setFieldValue("isPatient", !!(typeObj.RelatedPerson && typeObj.Patient));
        } else {
          setTypeRelatedPerson(false);
        }
      } catch (err) {
        failed(err?.response?.data?.message || err?.response?.data?.error || err?.message);
      } finally {
        setLoadingUserData(false);
      }
    })();
  }, [modalShow]);

  if (loadingUserData) return <FullPageSpinner />;

  const handleSwitch = () => {
    modalShow?.active
      ? handleDelete(modalShow?.id, modalShow.name?.[0]?.text)
      : handleEnableClick(modalShow?.id, modalShow.name?.[0]?.text);
  };


  const handleUpdateAgentId = () => {
    const practitionerLink = modalShow?.link?.[0]?.target?.reference;
    const [, practitionerId] = (practitionerLink || "").split("/");
    const agentId = formik?.values?.agentId;
    updateAgentId(practitionerId, agentId)
      .then((res) => {
        if (res?.data) {
          success("Agent ID updated successfully");
        } else {
          failed("Failed to update Agent ID");
        }
      })
      .catch((error) => {
        failed(error?.response?.data?.message || error.message);
      });
  };

  const computePractitionerFields = () => {
    return (
      <>
        <Fields
          fields={editBasicFieldsPractionerRowOne}
          formik={formik}
          isReadOnly={isReadOnly}
          handlePostalCodeChange={handlePostalCodeChange}
        />

        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.14)", marginBottom: "15px" }}>
          <Col xs lg="4">
            <ReactDatePicker
              keyField={"date_of_birth"}
              label={"Date of Birth"}
              formik={formik}
              placeholder={"Select Date"}
              hasValue={formik?.values?.["date_of_birth"]}
              displayAge={formik.errors.date_of_birth ? false : true}
              readOnly={isReadOnly}
              required={enforcePractitionerDOB}
              hideRequired={!enforcePractitionerDOB}
            />
          </Col>
          <Col xs lg="3">
            <SelectFiled
              keyField={"gender"}
              label={"Select Gender"}
              formik={formik}
              options={genderOptions}
              readOnly={isReadOnly}
              required={enforcePractitionerGender}
              hideRequired={!enforcePractitionerGender}
            />
          </Col>
          <Col>
            <SelectFiled
              keyField={"role"}
              label={"Role"}
              formik={formik}
              options={rolesOptions}
              onChange={handleRoleChange}
              readOnly={isReadOnly}
            />
          </Col>
        </Row>

        <Fields
          fields={editBasicFieldsPractionerRowThree.map((row) =>
            row.map((f) => {
              if (f.keyField === "address")
                return {
                  ...f,
                  required: enforcePractitionerAddress,
                  hideRequired: !enforcePractitionerAddress,
                };
              if (f.keyField === "city")
                return {
                  ...f,
                  required: enforcePractitionerCity,
                  hideRequired: !enforcePractitionerCity,
                };
              if (f.keyField === "country")
                return {
                  ...f,
                  required: enforcePractitionerCountry,
                  hideRequired: !enforcePractitionerCountry,
                };
              if (f.keyField === "region")
                return {
                  ...f,
                  required: enforcePractitionerProvince,
                  hideRequired: !enforcePractitionerProvince,
                };
              if (f.fieldType === "postalCode" || f.keyField === "postalCode")
                return {
                  ...f,
                  required: enforcePractitionerPostal,
                  hideRequired: !enforcePractitionerPostal,
                };
              return f;
            })
          )}
          formik={formik}
          isReadOnly={isReadOnly}
          handlePostalCodeChange={handlePostalCodeChange}
        />

        <Row style={{ borderTop: "1px solid rgba(0, 0, 0, 0.14)", paddingTop: "15px" }}>
          <Col>
            <SelectFiled
              keyField={"organization"}
              label={"Select Organization"}
              formik={formik}
              options={organizations}
              onChange={handleOrgChange}
              readOnly={true}
            />
          </Col>
        </Row>

        {roleSelected ? (
          <Fields
            fields={editBasicFieldsPractionerRowEight}
            formik={formik}
            isReadOnly={isReadOnly}
          />
        ) : null}

        <Row  style={{ borderTop: "1px solid rgba(0,0,0,0.14)", marginTop: 12, paddingTop: 12 }}>
          <Row style={{ fontWeight: "bold", marginBottom: 15, fontSize: 18 }}>Scope of Practice</Row>
          {isReadOnly ? (
            <>
              <Col xs lg="3">
                <MultiSelect
                  options={countryList}
                  keyField={"countryList"}
                  formik={formik}
                  isSelectAllEnable={true}
                  label={"Country"}
                  defaultValue={defaultValue}
                  style={{ width: "100%" }}
                  bindMethod={handleCountryChange}
                />
              </Col>
              <Col>
                <MultiSelect
                  options={
                    regionOptions?.map((option) => ({
                      ...option,
                      disabled: true,
                      checked: defaultValue?.includes(option?.value),
                      readOnly: isReadOnly,
                    })) || []
                  }
                  keyField={"scopeOfPractice"}
                  formik={formik}
                  label={"Province/State"}
                  defaultValue={defaultValue}
                  isSelectAll={
                    isReadOnly &&
                    defaultValue?.length > 0 &&
                    defaultValue?.length === regionOptions?.length
                  }
                  isSelectAllEnable={false}
                  readOnly={isReadOnly}
                />
              </Col>
            </>
          ) : (
            <>
              <Col xs lg="3">
                <MultiSelect
                  options={countryList}
                  keyField={"countryList"}
                  formik={formik}
                  isSelectAllEnable={true}
                  label={"Country"}
                  style={{ width: "100%" }}
                  bindMethod={handleCountryChange}
                  defaultValue={defaultCountryList}
                />
              </Col>
              <Col>
                <MultiSelect
                  options={regionOptions || []}
                  keyField={"scopeOfPractice"}
                  formik={formik}
                  label={"Province/State"}
                  defaultValue={defaultValue}
                  readOnly={isReadOnly}
                  isSelectAll={
                    defaultValue?.length > 0 &&
                    defaultValue?.length === regionOptions?.length
                  }
                  isSelectAllEnable={true}
                />
              </Col>
            </>
          )}
        </Row>

        {childrenOrgs.length > 0 && (
          <Row>
            <Col>
              <MultiSelect
                options={
                  childrenOrgs?.map((option) => ({
                    ...option,
                    disabled: true,
                    checked: defaultValuechildOrgs?.includes(option?.id),
                    readOnly: isReadOnly,
                  })) || []
                }
                keyField={"excludedOrgIds"}
                formik={formik}
                label={"Excluded Organizations for This Employee"}
                defaultValue={defaultValuechildOrgs}
                isSelectAll={
                  isReadOnly &&
                  defaultValuechildOrgs?.length > 0 &&
                  defaultValuechildOrgs?.length === childrenOrgs?.length
                }
                isSelectAllEnable={true}
                readOnly={childrenOrgs?.length > 0 ? isReadOnly : true}
                hideRequired={true}
              />
            </Col>
          </Row>
        )}

        {isCTIEnabledRef.current && (
          <Row>
            <Col>
              <div style={{ display: "flex", flexDirection: "row", gap: "10px", width: "100%" }}>
                <TextInput
                  keyField={"agentId"}
                  label={"Agent ID"}
                  formik={formik}
                  placeholder={"Agent ID"}
                  tooltip={"User identifier from telephony agent"}
                  hideRequired={true}
                  readOnly={isReadOnly}
                />
                {!isReadOnly && (
                  <Button style={{ marginTop: "35px" }} onClick={handleUpdateAgentId}>
                    Update Agent ID
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        )}
      </>
    );
  };

  const computePatientFields = () => {
    return (
      <>
        <Fields
          fields={editBasicFields}
          formik={formik}
          isReadOnly={isReadOnly}
          handlePostalCodeChange={handlePostalCodeChange}
          typeOfUser={modalShow?.type?.[0]}
        />
        <Row style={{ borderTop: "1px solid rgba(0, 0, 0, 0.14)", paddingTop: "15px" }}>
          <Col>
            <SelectFiled
              keyField={"organization"}
              label={"Select Organization"}
              formik={formik}
              options={organizations}
              onChange={handleOrgChange}
              readOnly={true}
            />
          </Col>
        </Row>
        <Row>
          {createAccount && (
            <Col sm lg="4">
              <SelectFiled
                keyField={"create_account"}
                label={"Create Account"}
                formik={formik}
                placeholder={"Create Account"}
                options={createAccountOptions}
                readOnly={!createAcctFlag}
                onChange={handleCreateAccountChange}
              />
            </Col>
          )}
        </Row>
      </>
    );
  };

  return (
    <Modal
      backdropClassName
      backdrop={"static"}
      show={modalShow}
      onHide={handleShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Employee Details</Modal.Title>
        <div className="">
          <Switch
            checked={modalShow?.active}
            onChange={() => handleSwitch()}
            color="primary"
            disabled={isReadOnly}
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <form
          className="common-form border-fields userAccount editUserModal"
          onSubmit={formik.handleSubmit}
          onChange={handleFormChange}
        >
          {modalShow?.type?.[0] == "Practitioner" || typeOfUser === "Practitioner"
            ? computePractitionerFields()
            : computePatientFields()}

          <Row>
            <Col>
              {hasAccess && (
                <>
                  <Button
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      handleShow();
                    }}
                    variant="secondary"
                    title="Cancel"
                  >
                    Cancel
                  </Button>
                  {!isReadOnly && (
                    <Button type="submit" isLoading={btnLoading}>
                      <img src={UpdateDetailsIcon} alt="" /> Update
                    </Button>
                  )}
                </>
              )}
            </Col>
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ alignSelf: "flex-end" }}>User Created on {ViewDate(createdAt)}</div>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
}